import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastController } from '@gruposaltaedu/liv-design-system/components';
import { I18nService } from '@gruposaltaedu/liv-i18n/core';
import { BehaviorSubject, Observable, fromEvent } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ConnectionService {
  private _connected: BehaviorSubject<boolean> = new BehaviorSubject(
    window.navigator.onLine
  );
  connected$: Observable<boolean> = this._connected.asObservable();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toastService: ToastController,
    private language: I18nService
  ) {
    this.onOnline();
    this.onOffline();
  }

  get isConnected(): boolean {
    return this._connected.value;
  }

  private onOnline(): void {
    fromEvent(window, 'online')
      .pipe(
        tap(() =>
          this.toastService.success({
            message: this.language.instant('messages.connection_success')
          })
        )
      )
      .subscribe(() => {
        this._connected.next(true);

        const redirect = this.route.snapshot.queryParamMap.get('redirect');
        const decodedUrl = redirect ? decodeURIComponent(redirect) : '/inicio';

        this.router.navigateByUrl(decodedUrl);
      });
  }

  private onOffline(): void {
    fromEvent(window, 'offline')
      .pipe(
        tap(() =>
          this.toastService.info({
            message: this.language.instant('messages.connection_failed')
          })
        )
      )
      .subscribe(() => {
        this._connected.next(false);

        this.router.navigate(['offline'], {
          queryParams: { redirect: this.router.url }
        });
      });
  }
}
